import { render } from "./echarts_relation.vue?vue&type=template&id=55ef9754"
import script from "./echarts_relation.vue?vue&type=script&lang=js"
export * from "./echarts_relation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__